export default {
  report: {
    stayingGuestReport: 'Báo cáo khách đang ở',
    internalCardUsingReport: 'Báo cáo sử dụng thẻ nội bộ',
    walkInGuestReport: 'Báo cáo khách Walk-in',
    incurredTransactionReport: 'Báo cáo chi tiết theo đặt phòng',
    paymentReport: 'Báo cáo thanh toán',
    groupGuestReport: 'Báo cáo khách đoàn',
    houseKeepingReport: 'Báo cáo buồng phòng',
    roomStatusChangeDiaryReport: 'Báo cáo nhật ký thay đổi trạng thái phòng',
    housekeepingTransSynthesisReport: 'Báo cáo tổng hợp giao dịch buồng phòng',
    oooAndOosRoomReport: 'Báo cáo phòng OOO/OOS',
    houseKeepingMustCheckReport: 'Báo cáo buồng phòng cần kiểm tra',
    lostPropertyReport: 'Báo cáo đồ thất lạc',
    guestCardUsingReport: 'Báo cáo sử dụng thẻ của khách',
    creatingSmartKeyReport: 'Báo cáo tạo khóa từ',
    guestDepatureReport: 'Báo cáo khách đi',
    laundryReport: 'Báo cáo giặt là',
    compensationReport: 'Báo cáo đền bù'
  }
}
